import React, { useState, useEffect, Fragment, useMemo } from 'react';
import Checkbox from '../../../common/Checkbox';
import { toast } from 'react-toastify';
import { decodeId, getProductEncodedUrl } from '../../../../helpers';
import { useDispatch } from 'react-redux';
import { fetchEditVariant } from '../../../../actions/items';
import InputWrapper from '../../../common/InputWrapper';
import Button from '../../../common/Button';
import { useHistory } from 'react-router-dom';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const DEFAULT_MONOBOX_VALUES = {
  multiplicity: '',
  shortName: '',
};

const CreateMonobox = (props) => {
  const { product, monoboxes, variant, updateMonoboxesState } = props;

  const history = useHistory();
  const dispatch = useDispatch();

  const { t } = useAutoTranslation();

  const [createFirstMonobox, setCreateFirstMonobox] = useState(false);
  const [firstMonoboxValues, setFirstMonoboxValues] = useState(DEFAULT_MONOBOX_VALUES);

  const parentPackageId = variant.id; //id родительского варианта, к которому будут привязаны новые монокороба

  const handleMonoboxesValues = (id, value) => {
    setFirstMonoboxValues({
      ...firstMonoboxValues,
      [id]: value,
    });
  };

  const handleCreateFirstMonobox = () => setCreateFirstMonobox(!createFirstMonobox);

  const createMonobox = async () => {
    if (!firstMonoboxValues.multiplicity || !firstMonoboxValues.shortName) {
      toast.error('Заполните форму создания монокороба');
      return;
    }

    const newMonoboxData = {
      parentPackageId,
      multiplicity: firstMonoboxValues.multiplicity,
      shortName: firstMonoboxValues.shortName,
      productId: decodeId(product.id),
      isArchived: false,
      barcodes: [],
    };

    if (!parentPackageId) {
      toast.error('Не найден parentPackageId');
      return;
    }

    try {
      const res = await dispatch(fetchEditVariant(newMonoboxData));
      if (res?.product) {
        updateMonoboxesState(res.product.variants);
        setCreateFirstMonobox(false);
        toast.info(`Первый монокороб для ${parentPackageId} успешно создан`);
        setFirstMonoboxValues(DEFAULT_MONOBOX_VALUES);
      }
    } catch (error) {
      toast.error(error.data.errors[0].message);
    }
  };

  //! Вынести в helpers.js - есть такие же функции в SingleVariantPage
  const resetAllInputValuesFromTemplateVariant = (variant) => {
    const emptyDimensions = {
      depth: 0,
      height: 0,
      width: 0,
    };

    if (variant.barcodes) {
      variant.barcodes = variant.barcodes.map((barcode) => {
        return {
          ...barcode,
          value: '',
        };
      });
    }

    variant.dimensions = emptyDimensions;
    variant.dimensionsFact = emptyDimensions;
    variant.marginParams = {
      marketplaceCosts: [],
    };

    if (variant.optionsUsed) {
      variant.optionsUsed = variant.optionsUsed.map((option) => {
        return {
          ...option,
          stringValue: '',
          stringValue: null,
          decimalValue: null,
        };
      });
    }

    variant.ordering = 0;
    variant.price = 0;

    if (variant.prices) {
      variant.prices = variant.prices.map((price) => {
        return {
          ...price,
          value: 0,
        };
      });
    }

    variant.vat = 'NO_VAT';
    variant.weight = 0;
    variant.weightFact = 0;
    variant.article = '';
    variant.extId = '';

    if (variant.eshopSettings) {
      variant.eshopSettings = variant.eshopSettings.map((setting) => {
        return {
          ...setting,
          extId: '',
        };
      });
    }

    return variant;
  };

  const handleAddManualVariant = () => {
    let newVariantData = resetAllInputValuesFromTemplateVariant(variant);

    const dataToNewVariantPage = {
      newVariantData,
      isMonoboxesBlock: true,
      parentPackageId,
    };

    if (!parentPackageId) {
      toast.error('Не найден parentPackageId');
      return;
    }

    //* Чтобы переключить на variants
    // history.push(getProductEncodedUrl(`${product.id}/variants/new`), dataToNewVariantPage);

    history.push(getProductEncodedUrl(`${product.id}/monoboxes/new`), dataToNewVariantPage);
  };

  return (
    <>
      {!monoboxes.length ? (
        <div className="form-group mt-3">
          <Checkbox
            label={t('Использовать монокороба')}
            id="displayMonoboxes"
            labelStyle={{ fontWeight: '400' }}
            onChange={handleCreateFirstMonobox}
          />
        </div>
      ) : null}
      {createFirstMonobox ? (
        <div className="col-sm-7">
          <InputWrapper
            type="text"
            label={t('Название')}
            id="shortName"
            onChange={(e) => handleMonoboxesValues('shortName', e.target.value)}
            value={firstMonoboxValues.shortName}
          />
          <br />
          <InputWrapper
            type="number"
            label={t('Кратность')}
            id="multiplicity"
            onChange={(e) => handleMonoboxesValues('multiplicity', e.target.value)}
            value={firstMonoboxValues.multiplicity}
          />
          <Button
            type="button"
            className="btn btn-danger waves-effect waves-light mt-2"
            onClick={() => createMonobox()}
            text={t('Создать новый монокороб')}
          >
            <i className="fe-file-plus" /> {t('Создать новый монокороб')}
          </Button>
        </div>
      ) : null}
      {monoboxes.length ? (
        <div className="row variants-buttons">
          <div className="col-12">
            <div className="text-lg-right">
              <button
                type="button"
                className="btn btn-danger waves-effect waves-light"
                style={{ marginTop: '-45px' }}
                onClick={() => handleAddManualVariant(true, variant.id)}
              >
                <i className="fe-file-plus" /> {t('Новый монокороб')}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default CreateMonobox;
